"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {};
        GState.bind(this, ['permissionRequest']);
    },
    formatList: function () {
        return this.state.permissionRequest.list.map(each => {
            return typeof each == 'string' ? { type: each } : each;
        });
    },
    onGranted: function (index, scope, e) {
        this.state.permissionRequest.list[index] = {
            ...scope,
            access: e.target.checked ? 'GRANTED' : 'DENIED'
        };
    },
    onDone: function () {
        this.state.permissionRequest.callback(this.formatList());
    },
    onCancel: function () {
        this.state.permissionRequest.callback();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/AskPermission.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Favicon_template = require("./Favicon.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Favicon_tag = marko_loadTag(Favicon_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "position-fixed w-100 h-100 top-0 left-0 d-flex align-items-center center",
        style: "z-index:10"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("ae6581"),
    marko_node0 = marko_createElement("div", {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      }, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "d-flex align-items-center"
      },
    marko_attrs2 = {
        "class": "mx-2"
      },
    marko_node1 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "text-muted"
      },
    marko_node2 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "list-unstyled"
      },
    marko_node3 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "text-right"
      },
    marko_attrs6 = {
        "class": "btn btn-secondary btn-lg mr-1"
      },
    marko_attrs7 = {
        "class": "btn btn-primary btn-lg"
      },
    marko_attrs8 = {
        "class": "py-25 form-group"
      },
    marko_attrs9 = {
        "class": "checkbox checkbox-secondary"
      };

function getScopeLabel( scope ){
  
  switch( scope ){
    case 'user.first_name': return 'First Name of the User'
    case 'user.last_name': return 'First Name of the User'
    case 'user.email': return 'Email Address of the User'
    case 'tenant.name': return 'Name of the Institution'
    case 'tenant.apps': return 'Developer Applications'

    // Unknow scope
    default: return false
  }
};

function render(input, out, __component, component, state) {
  var data = input;

  if (state.permissionRequest) {
    const { type, requestor } = state.permissionRequest

    out.be("div", marko_attrs0, "0", component);

    Row_tag({
        class: "m-0 w-100 d-flex justify-content-center",
        renderBody: function(out) {
          out.n(marko_node0, component);

          WSAdapt_tag({
              ns: "col-4",
              qs: "col-5",
              hs: "col-6",
              class: "theme-bg rounded shadow-lg px-4 py-3",
              renderBody: function(out) {
                out.be("div", marko_attrs1, "4", component);

                Favicon_tag(marko_assign({
                    width: 42
                  }, requestor), out, __component, "5");

                out.e("h5", marko_attrs2, "6", component, 1)
                  .t(requestor.name, component);

                out.ee();

                out.n(marko_node1, component);

                out.be("p", marko_attrs3, "8", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Request permissions to access some information: ");
                    }
                  }, out, __component, "9");

                out.ee();

                out.n(marko_node2, component);

                out.be("ul", marko_attrs4, "11", component);

                const scopeList = component.formatList()

                var $for$0 = 0;

                marko_forOf(scopeList, function(scope, index) {
                  var $keyScope$0 = "[" + (($for$0++) + "]");

                  const label = getScopeLabel( scope.type )

                  if (label) {
                    out.be("li", marko_attrs8, "@" + index, component);

                    out.be("div", marko_attrs9, "12" + $keyScope$0, component);

                    _preserve_tag({
                        n: true,
                        renderBody: function(out) {
                          out.e("input", {
                              type: "checkbox",
                              id: scope.type,
                              checked: scope.access == "GRANTED"
                            }, "13" + $keyScope$0, component, 0, 0, {
                              onchange: __component.d("change", "onGranted", false, [
                                  index,
                                  scope
                                ])
                            });
                        }
                      }, out, __component, "13" + $keyScope$0);

                    out.be("label", {
                        "for": scope.type,
                        "class": "font-medium-1"
                      }, "14" + $keyScope$0, component);

                    Locale_tag({
                        text: label
                      }, out, __component, "15" + $keyScope$0);

                    out.ee();

                    out.ee();

                    out.ee();
                  }
                });

                out.ee();

                out.n(marko_node3, component);

                out.be("div", marko_attrs5, "17", component);

                out.be("button", marko_attrs6, "18", component, null, 0, {
                    onclick: __component.d("click", "onCancel", false)
                  });

                Locale_tag({
                    text: "Cancel"
                  }, out, __component, "19");

                out.ee();

                out.be("button", marko_attrs7, "20", component, null, 0, {
                    onclick: __component.d("click", "onDone", false)
                  });

                Locale_tag({
                    text: "Done"
                  }, out, __component, "21");

                out.ee();

                out.ee();
              }
            }, out, __component, "3");
        }
      }, out, __component, "1");

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
